import constants from '../constants/index';

const TeacherActions = {
	requestTeachersSuccess: function(participants) {
		return {
			type: constants.REQUEST_TEACHERS_SUCCESS,
			payload: {
				participants
			}
		};
	},

	requestTeachersFail: function() {
		return {
			type: constants.REQUEST_TEACHERS_FAIL,
			payload: {

			}
		};
	},

	selectTeacher: function(id, selected) {
		return {
			type: constants.SELECT_TEACHER,
			payload: {
				id: id,
				selected: selected
			}
		};
	},

	selectTeachers: function(ids, selected, group_id) {
		return {
			type: constants.SELECT_TEACHERS,
			payload: {
				ids: ids,
				selected: selected
			}
		};
	},

	unSelectTeachers: function() {
		return {
			type: constants.UNSELECT_TEACHERS,
			payload: {}
		};
	}
};

export default TeacherActions;


/** WEBPACK FOOTER **
 ** ./src/js/actions/teacher_actions.js
 **/